import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'
import {
  breakpoint,
  fontSize,
  pxToRem,
  size,
  width,
} from '@twistopayments/design-system/styles'

export const wrap = css`
  width: 100%;
  margin: 0 auto ${size[80]};

  ${breakpoint.up('md')} {
    width: fit-content;
  }
`

export const title = css`
  /* text-align: center; */
  font-weight: 700;
  font-size: ${pxToRem(28)};
  margin-bottom: ${size[24]};
  margin-left: ${size[24]};
  line-height: 100%;

  span {
    color: #3bbab2;
  }

  ${breakpoint.up('md')} {
    margin-left: 0;
    text-align: center;
    font-size: ${pxToRem(48)};
    margin-bottom: ${size[48]};
  }
`

export const list = css`
  list-style-type: none;
  margin: 0;
  padding: 0;
  padding-inline: ${size[16]};
  scroll-behavior: smooth;
  overflow-x: scroll;
  display: flex;
  gap: ${size[8]};
  scroll-snap-type: x mandatory;
  scroll-padding-left: 40px;

  ${breakpoint.up('md')} {
    padding-inline-start: 0;
    overflow-x: unset;
    display: block;
    scroll-snap-type: unset;
  }
`

export const card = (theme: Theme) => css`
  max-width: ${width.container.compact};
  width: calc(100vw - 40px);
  border: 2px solid #9c919e3d;
  border-radius: ${theme.borderRadius.md};
  padding: ${size[16]};
  margin-bottom: ${size[24]};
  flex-shrink: 0;

  transition:
    background-color 200ms linear,
    border-color 200ms linear;

  ${breakpoint.up('md')} {
    padding: ${size[24]};
    width: unset;
    border-radius: ${theme.borderRadius.lg};
  }
`

export const cardActive = (theme: Theme) => css`
  ${breakpoint.up('md')} {
    border-color: ${theme.palette.primary.mainContrast};
    background-color: ${theme.palette.primary.lowContrast};
  }
`

export const cardTitle = css`
  margin-bottom: ${size[16]};
  font-weight: 500;
  font-size: ${fontSize.sm};

  ${breakpoint.up('md')} {
    margin-bottom: ${size[24]};
    font-size: ${fontSize.md};
  }
`

export const cardDesc = (theme: Theme) => css`
  color: ${theme.palette.tertiary.mediumContrastAlternative};
  font-size: ${fontSize.sm};
  margin-bottom: ${size[16]};

  ${breakpoint.up('md')} {
    font-size: ${fontSize.md};
    margin-bottom: ${size[24]};
  }
`

export const cardLink = css`
  font-weight: 500;
  font-size: ${fontSize.sm};
  margin-bottom: ${size[16]};

  ${breakpoint.up('md')} {
    margin-bottom: ${size[24]};
  }
`

export const content = css`
  display: flex;
  justify-content: center;
  gap: ${size[32]};
`

export const imageContainer = (theme: Theme) => css`
  display: none;

  max-height: 868px;
  overflow-y: auto;
  padding-right: ${size[80]};
  scroll-snap-type: y mandatory;
  scroll-behavior: smooth;
  scrollbar-color: ${theme.palette.primary.mainContrast} transparent;

  ${breakpoint.up('md')} {
    display: block;
    min-height: 768px;
  }
`

export const img = (theme: Theme) => css`
  border-radius: ${theme.borderRadius.lg};
  width: 500px;
  height: 100%;
  scroll-snap-align: start;
`

export const cardImg = (theme: Theme) => css`
  width: 100%;
  height: 450px;
  border-radius: ${theme.borderRadius.md};
  margin-bottom: ${size[24]};

  ${breakpoint.up('md')} {
    display: none;
  }
`
